
import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 border-b border-blue-500/20 shadow-lg shadow-blue-500/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent cursor-pointer" style={{ fontFamily: '"Pacifico", serif' }}>
            Madina Associates
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            <button onClick={() => scrollToSection('hero')} className="px-4 xl:px-5 py-2.5 text-gray-700 hover:text-blue-600 transition-all rounded-lg hover:bg-blue-50 font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="px-4 xl:px-5 py-2.5 text-gray-700 hover:text-blue-600 transition-all rounded-lg hover:bg-blue-50 font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base">
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className="px-4 xl:px-5 py-2.5 text-gray-700 hover:text-blue-600 transition-all rounded-lg hover:bg-blue-50 font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base">
              Services
            </button>
            <button onClick={() => scrollToSection('properties')} className="px-4 xl:px-5 py-2.5 text-gray-700 hover:text-blue-600 transition-all rounded-lg hover:bg-blue-50 font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base">
              Properties
            </button>
            <button onClick={() => scrollToSection('projects')} className="px-4 xl:px-5 py-2.5 text-gray-700 hover:text-blue-600 transition-all rounded-lg hover:bg-blue-50 font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base">
              Projects
            </button>
            <button onClick={() => scrollToSection('contact')} className="ml-3 bg-gradient-to-r from-red-600 to-blue-600 text-white px-5 xl:px-7 py-2.5 rounded-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all font-bold whitespace-nowrap cursor-pointer text-sm xl:text-base">
              Contact Us
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-lg transition-all cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-md border-t border-blue-500/20 shadow-lg">
          <div className="px-4 sm:px-6 py-4 space-y-1 max-h-screen overflow-y-auto">
            <button onClick={() => scrollToSection('hero')} className="block w-full text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-3 px-4 rounded-lg transition-all cursor-pointer font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-3 px-4 rounded-lg transition-all cursor-pointer font-medium">
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-3 px-4 rounded-lg transition-all cursor-pointer font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('properties')} className="block w-full text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-3 px-4 rounded-lg transition-all cursor-pointer font-medium">
              Properties
            </button>
            <button onClick={() => scrollToSection('projects')} className="block w-full text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-3 px-4 rounded-lg transition-all cursor-pointer font-medium">
              Projects
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left bg-gradient-to-r from-red-600 to-blue-600 text-white px-4 py-3 rounded-lg hover:shadow-lg hover:shadow-blue-500/50 font-bold cursor-pointer mt-2">
              Contact Us
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
